// extracted by mini-css-extract-plugin
module.exports = {"renewalModal":"renewalModal--n1Sgu","renewalFooter":"renewalFooter--3KtAI","renewalText":"renewalText--4ucXR"};